import { cx } from "cva";
import React from "react";

import { SubtleButtonProps, variants } from ".";

export const SubtleButton = ({
  className,
  children,
  type = "button",
  align,
  radius,
  color,
  ...props
}: Readonly<React.ButtonHTMLAttributes<HTMLButtonElement> & SubtleButtonProps>) => (
  <button type={type} className={cx(className, variants({ align, radius }))} {...props}>
    {children}
  </button>
);
